import React, { useEffect, useState, useRef, useContext } from "react";
import Page_GameStatusLog from "./Components/COM_GameUpdateLog";
import COM_GameUpdateStatus from "./Components/COM_GameUpdateStatus 2";

// import useFirebase from "./Hooks/useFirebase";
// import useRoleAuth from "./Hooks/useRoleAuth";

import CTX from "./Hooks/useContext";

import { Button, Table } from "@mantine/core";
import COM_Nav_Global from "./Components/COM_Nav_Global";
import COM_Users_Setting from "./Components/COM_Users_Setting";

// const REACT_APP_ECLIPSE_API = env.VITE_REACT_APP_ECLIPSE_API;
const {
  REACT_APP_ECLIPSE_API_PUBLIC,
  REACT_APP_ECLIPSE_API,
  REACT_APP_ECLIPSE_API_Local,
} = process.env;

export const Page_Setting = () => {
  const ctx = useContext(CTX);

  // console.log("--------------------------- Page_Setting , ctx", ctx.current);

  return (
    <>
      <div>
        <COM_Nav_Global />

        <h1>Setting</h1>
        <div className="glo_system_ui">
          {ctx.current?.DB_Users.u_auth === "3" ||
          ctx.current?.DB_Users.u_auth === "2"
            ? "* this pannel only show for admin(dev)"
            : "For Admin and Supervisor only"}
        </div>
        <br />
        <div className="glo_system_ui">
          {ctx.current?.DB_Users.u_auth === "3" ||
          ctx.current?.DB_Users.u_auth === "2" ? (
            <COM_Users_Setting />
          ) : (
            "For Admin and Supervisor only"
          )}
        </div>

        <br />
      </div>
    </>
  );
};

export default Page_Setting;
